import React from 'react';
import { MainLayout } from '@/components/layout/MainLayout';
import { EnvironmentalPortfolioDashboard } from '@/components/portfolio/EnvironmentalPortfolioDashboard';

const Portfolio = () => {
  return (
    <MainLayout>
      <EnvironmentalPortfolioDashboard />
    </MainLayout>
  );
};

export default Portfolio;